import { useTranslation } from 'react-i18next';
import AcceptPlanModal from './AcceptPlanModal/AcceptPlanModal';
import statuses from '../../../MediaPlansTable/helpers/statuses';

export interface AcceptPlanFlowProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  status: string;
  isLoading?: boolean;
  error?: string | null;
}

function AcceptPlanFlow({
  open,
  onClose,
  onSuccess,
  status,
  error,
  isLoading,
}: AcceptPlanFlowProps) {
  const { t } = useTranslation();

  let header = '';
  let text: string | null = null;
  let cancelText = '';
  let proceedText = '';

  if (status === statuses.BOOKED) {
    header = t('mediaPlanning.metaBooking.modals.acceptPlan.header');
    text = t('mediaPlanning.metaBooking.modals.acceptPlan.text');
    cancelText = t('mediaPlanning.metaBooking.modals.acceptPlan.cancelText');
    proceedText = t('mediaPlanning.metaBooking.modals.acceptPlan.proceedText');
  }

  if (status === statuses.ACCEPTED) {
    header = t('mediaPlanning.metaBooking.modals.unlockPlan.header');
    text = t('mediaPlanning.metaBooking.modals.unlockPlan.text');
    cancelText = t('mediaPlanning.metaBooking.modals.unlockPlan.cancelText');
    proceedText = t('mediaPlanning.metaBooking.modals.unlockPlan.proceedText');
  }

  if (!header) return null;

  const modalText = (
    <>
      {!error && <div>{text}</div>}
      {error && (
        <div style={{ marginTop: 12, color: '#525F81', fontWeight: 400 }}>
          {error}
        </div>
      )}
    </>
  );

  return (
    <AcceptPlanModal
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      header={header}
      text={modalText}
      cancelText={error ? 'OK' : cancelText}
      proceedText={proceedText}
      isLoading={isLoading}
      closeOnSuccess={false}
      type={error ? 'error' : 'information'}
    />
  );
}

export default AcceptPlanFlow;
